import { getOrgId } from '@/utils/tool';
import { Router } from 'vue-router';

const commonData = {
  router: null as Router | null,
  originId: '',
};
export default commonData;

export function showDialog() {
  const chatElement = document.querySelector('.gptbots-chat');
  if (chatElement) {
    (chatElement as HTMLElement).click();
  }
}

export function interceptOrgId() {
  let can = true;
  const href = location.href;
  if (location.host.includes('localhost')) {
    return can;
  }
  if (href.includes('type=') && (href.includes('&appKey=') || href.includes('&appId='))) {
    can = true;
  }
  if (commonData.router && commonData.originId && getOrgId() !== commonData.originId) {
    can = false;
    commonData.router.push({ name: 'appList' });
  } else {
    commonData.originId = getOrgId();
    can = true;
  }
  return can;
}
